import {
  ComponentState,
  IncidentSeverity,
  IncidentStatus,
  OverallState,
} from "../../interfaces/paymentHealth.interface";

type BannerType = "success" | "info" | "warning" | "error";

export function overallStateMeta(state: OverallState): {
  label: string;
  color: string;
  bannerType: BannerType;
} {
  switch (state) {
    case ComponentState.Operational:
      return {
        label: "All systems operational",
        color: "#52c41a",
        bannerType: "success",
      };
    case ComponentState.Degraded:
      return { label: "Degraded", color: "#faad14", bannerType: "warning" };
    case ComponentState.PartialOutage:
      return {
        label: "Partial outage",
        color: "#fa8c16",
        bannerType: "warning",
      };
    case ComponentState.MajorOutage:
      return { label: "Major outage", color: "#ff4d4f", bannerType: "error" };
    case "unknown":
    default:
      return {
        label: "Health indecisive - monitoring degraded",
        color: "#8c8c8c",
        bannerType: "info",
      };
  }
}

export function componentStateMeta(state: ComponentState): {
  label: string;
  color: string;
} {
  switch (state) {
    case ComponentState.Operational:
      return { label: "Operational", color: "green" };
    case ComponentState.Degraded:
      return { label: "Degraded", color: "gold" };
    case ComponentState.PartialOutage:
      return { label: "Partial outage", color: "orange" };
    case ComponentState.MajorOutage:
      return { label: "Major outage", color: "red" };
    default:
      return { label: state, color: "default" };
  }
}

export function severityMeta(severity: IncidentSeverity): {
  label: string;
  color: string;
} {
  switch (severity) {
    case IncidentSeverity.Degraded:
      return { label: "Degraded", color: "gold" };
    case IncidentSeverity.PartialOutage:
      return { label: "Partial outage", color: "orange" };
    case IncidentSeverity.MajorOutage:
      return { label: "Major outage", color: "red" };
    default:
      return { label: severity, color: "default" };
  }
}

export function statusMeta(status: IncidentStatus): {
  label: string;
  color: string;
} {
  switch (status) {
    case IncidentStatus.Open:
      return { label: "Open", color: "red" };
    case IncidentStatus.Monitoring:
      return { label: "Monitoring", color: "blue" };
    case IncidentStatus.Resolved:
      return { label: "Resolved", color: "green" };
    case IncidentStatus.FalsePositive:
      return { label: "False positive", color: "default" };
    default:
      return { label: status, color: "default" };
  }
}
